<template>
  <div class="view-container">
    <BjDrawerForm ref="BjDrawerForm" :form="form" label-position="top" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
      <BjDivider>{{ $t('ChannelManagement.new.title') }}
        <template #right>
          <BjLogButton v-if="isEdit" :id="form.id" permission="BusinessChannelOnlineCsgList_Log" :title="form.name" api="channelApi" />
        </template>
      </BjDivider>
      <el-col :span="24">
        <el-form-item :label="$t('ChannelManagement.new.Channel')" prop="channelTypeCode">
          <BjSelectLov v-model="form.channelTypeCode" lov-code="SCHL.CHANNEL_TYPE" :disabled="isEdit" @change="getChannelName" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('ChannelManagement.csg.name')" prop="name">
          <BjInput v-model="form.name" clearable />
        </el-form-item>
      </el-col>
      <!-- ChannelAdvisor -->
      <div v-if="form.channelTypeCode === '1'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <!-- apiServiceUrl 写死 https://api.channeladvisor.com/oauth2/token -->
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable disabled :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <!-- 配送中心id  -->
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.project')" prop="distributionCenterId">
            <BjInput v-model="form.distributionCenterId" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <!-- Authorization  -->
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.Header.empower')" prop="authorization">
            <BjInput v-model="form.authorization" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <!-- 刷新令牌  -->
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.authAccount')" prop="refreshToken">
            <BjInput v-model="form.refreshToken" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- Shopify(legacy) -->
      <div v-else-if="form.channelTypeCode === '3'">
        <el-col :span="24">
          <el-form-item label="Client ID" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Client Secret" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-form-item :label="$t('ChannelManagement.Header.thr')" prop="distributionCenterType">
            <BjSelectLov v-model="form.distributionCenterType" :option-list="CANG_LIST" @change="changeKu" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit && form.distributionCenterType == 1">
          <el-form-item :label="$t('ChannelManagement.Header.two')" prop="cangCenterName">
            <BjSelectLov v-model="form.cangCenterName" :option-list="KU_LIST" @change="chooseCenter"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-button style="margin-bottom:5px" type="primary" class="main-btn" @click="getRemarks()">{{$t('ChannelManagement.Header.api')}}</el-button>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <BjInput v-model="ShopifyRemarks" :placeholder="$t('ChannelManagement.Header.api')" disabled type="textarea" show-word-limit autosize/>
        </el-col>
      </div>
      <!-- WooCommerce -->
      <div v-else-if="form.channelTypeCode === '5'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.wooCommerce.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.wooCommerce.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.wooCommerce.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- Magento -->
      <div v-else-if="form.channelTypeCode === '6'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.magento.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.magento.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.magento.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.magento.bpCode')" prop="bpCode">
            <BjInput v-model="form.bpCode" clearable :disabled="isEdit" />
          </el-form-item>
        </el-col>
      </div>
      <!-- CIN7 -->
      <div v-else-if="form.channelTypeCode === '7'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- Maropost -->
      <div v-else-if="form.channelTypeCode === '8'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.appKeyNew')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.bpCode')" prop="bpCode">
            <BjInput v-model="form.distributionCenterId" clearable />
          </el-form-item>
        </el-col>
      </div>
      <!-- BigCommerce -->
      <div v-else-if="form.channelTypeCode === '11'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.maropost.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- unleashed -->
      <div v-else-if="form.channelTypeCode === '12'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- NetSuite -->
      <div v-else-if="form.channelTypeCode === '13'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.channelAdvisor.authAccount')" prop="refreshToken">
            <BjInput v-model="form.refreshToken" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="consumerKey" prop="consumerKey">
            <BjInput v-model="form.consumerKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="consumerSecret" prop="consumerSecret">
            <BjInput v-model="form.consumerSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- CIN7 Core -->
      <div v-else-if="form.channelTypeCode === '19'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7Core.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7Core.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7.apiServiceUrl')">
            <BjInput v-model="form.apiServiceUrl" clearable :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.cin7.bpCode')">
            <BjInput v-model="form.bpCode" clearable />
          </el-form-item>
        </el-col>
      </div>
      <!-- NetSuite fast retailer -->
      <div v-else-if="form.channelTypeCode === '20'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appKey')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appSecret')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="consumerKey" prop="consumerKey">
            <BjInput v-model="form.consumerKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="consumerSecret" prop="consumerSecret">
            <BjInput v-model="form.consumerSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- LIXING-MULTI -->
      <div v-else-if="form.channelTypeCode === '21'">
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appKey1')" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.appSecret1')" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-form-item :label="$t('ChannelManagement.Header.thr')" prop="distributionCenterType">
            <BjSelectLov v-model="form.distributionCenterType" :option-list="CANG_LIST" @change="changeKu" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit && form.distributionCenterType == 1">
          <el-form-item :label="$t('ChannelManagement.Header.two')" prop="cangCenterName">
            <BjSelectLov v-model="form.cangCenterName" :option-list="KU_LIST" @change="chooseCenter"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-button style="margin-bottom:5px" type="primary" class="main-btn" @click="getRemarks()">{{$t('ChannelManagement.Header.api')}}</el-button>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <BjInput v-model="LIXINGRemarks" :placeholder="$t('ChannelManagement.Header.api')" disabled type="textarea" show-word-limit autosize/>
        </el-col>
      </div>
      <!-- Shopify -->
      <div v-else-if="form.channelTypeCode === '22'">
        <el-col :span="24">
          <el-form-item label="Client ID" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Client Secret" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-form-item :label="$t('ChannelManagement.Header.thr')" prop="distributionCenterType">
            <BjSelectLov v-model="form.distributionCenterType" :option-list="CANG_LIST" @change="changeKu" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit && form.distributionCenterType == 1">
          <el-form-item :label="$t('ChannelManagement.Header.two')" prop="cangCenterName">
            <BjSelectLov v-model="form.cangCenterName" :option-list="KU_LIST" @change="chooseCenter"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-button style="margin-bottom:5px" type="primary" class="main-btn" @click="getRemarks()">{{$t('ChannelManagement.Header.api')}}</el-button>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <BjInput v-model="ShopifyRemarks" :placeholder="$t('ChannelManagement.Header.api')" disabled type="textarea" show-word-limit autosize/>
        </el-col>
      </div>
      <!-- Edi tools -->
      <div v-else-if="form.channelTypeCode === '23'">
        <el-col :span="24">
          <el-form-item label="AppKey" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="AppSecret" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
      </div>
      <!-- Shopify Fulfillment Service -->
      <div v-else-if="form.channelTypeCode === '24'">
        <el-col :span="24">
          <el-form-item label="Client ID" prop="appKey">
            <BjInput v-model="form.appKey" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Client Secret" prop="appSecret">
            <BjInput v-model="form.appSecret" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('ChannelManagement.csg.shopify.apiServiceUrl')" prop="apiServiceUrl">
            <BjInput v-model="form.apiServiceUrl" clearable :disabled="isEdit" :maxlength="MAX_LENGTH.REMARK" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24" v-if="isEdit">
          <el-form-item :label="$t('ChannelManagement.Header.thr')" prop="distributionCenterType">
            <BjSelectLov v-model="form.distributionCenterType" :option-list="CANG_LIST" @change="changeKu" />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24" v-if="isEdit && form.distributionCenterType == 1">
          <el-form-item :label="$t('ChannelManagement.Header.two')" prop="cangCenterName">
            <BjSelectLov v-model="form.cangCenterName" :option-list="KU_LIST" @change="chooseCenter"/>
          </el-form-item>
        </el-col> -->
        <el-col :span="24" v-if="isEdit">
          <el-button style="margin-bottom:5px" type="primary" class="main-btn" @click="getRemarks()">{{$t('ChannelManagement.Header.api')}}</el-button>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <BjInput v-model="ShopifyRemarks" :placeholder="$t('ChannelManagement.Header.api')" disabled type="textarea" show-word-limit autosize/>
        </el-col>
      </div>

      <!-- 开始时间 -->
      <el-col v-if="!['4','23'].includes(form.channelTypeCode)" :span="24">
        <el-form-item :label="$t('billingPage.startDate')" prop="orderStartTime">
          <el-date-picker
            :disabled="!$store.getters.cusId || isEdit"
            v-model="form.orderStartTime"
            class="full-width"
            format="dd/MM/yyyy HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :picker-options="pickerOptions"
            :placeholder="$t('billingPage.startDate')"
          />
        </el-form-item>
      </el-col>
      <!-- 商品运费险 -->
      <el-col v-if="!$store.getters.cusId" :span="24">
        <el-form-item>
          <template #label>
              {{ $t('ChannelManagement.csg.channelAdvisor.WhetherGoods') }}
              <el-tooltip effect="dark" placement="top-start" :content="$t('ChannelManagement.csg.channelAdvisor.PleaseNote')">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
          <el-switch v-model="form.needInsurance" />
        </el-form-item>
      </el-col>
      <!-- 库存同步开关  3:Shopify(legacy) 且 22:Shopify 且 admin端 -->
      <el-col v-if="['3','22'].includes(form.channelTypeCode)&&!$store.getters.cusId" :span="24">
        <el-form-item>
          <template #label>
            {{ $t('ExternalPlatformProducts.inventory') }}
          </template>
          <el-switch v-model="form.isStockSync" :inactive-value="0" :active-value="1"/>
        </el-form-item>
      </el-col>
      <!-- 抓单回写标签  3:Shopify(legacy) 且 22:Shopify -->
      <el-col v-if="['3','22'].includes(form.channelTypeCode)" :span="24">
        <el-form-item>
          <template #label>
            {{ $t('ExternalPlatformProducts.Capture') }}
            <el-tooltip effect="dark" placement="top" :content="$t('ExternalPlatformProducts.CaptureTip')">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <el-switch v-model="form.isWriteBackCapture"/>
        </el-form-item>
      </el-col>
      
    </BjDrawerForm>
  </div>
</template>
<script>
import { commonApi, channelApi,reportApi } from '@/api';

const getDefaultForm = () => {
  return {
    channelTypeCode: '3',
    name: null,
    appKey: null,
    appSecret: null,
    apiServiceUrl: null,
    bpCode: null,
    authAccount: null,
    accountCode: '001',
    project: 'CSG',
    needInsurance: false,
    isStockSync: 0,
    isWriteBackCapture: false,
    onlineStoreTypeCode: 'basic',
    autoTableStatus: '1',
    channelWarehouseName: null,
    channelWarehouseId: null,
    manager: 'Eric Yang',
    salesOrganizingId: null,
    invoiceTypeCode: 'plain-invoice',
    taxCode: 'S1',
    currency: 'AUD',
    url: '',
    distributionCenterType: 0,
    cangCenterName: '',
    distributionCenterName: '',
    // ChannelAdvisor 店铺字段
    distributionCenterId: null,
    authorization: null,
    refreshToken: null,
    orderStartTime: null,
  };
};

export default {
  data() {
    const validateCenterName = (rule, value, callback) => {
      if (!this.form.distributionCenterName) {
        callback(new Error(this.$t('chooseText')));
      } else {
        callback();
      }
    };
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        channelTypeCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appKey: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appSecret: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        apiServiceUrl: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        bpCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        accountCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        project: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        distributionCenterType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        cangCenterName: { required: true, validator: validateCenterName, trigger: 'change' },
        // ChannelAdvisor 店铺字段
        distributionCenterId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        authorization: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        refreshToken: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        consumerKey: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        consumerSecret: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // orderStartTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      ruleLabel: 'Shopify',
      CANG_LIST: [
        { label: this.$t('ChannelManagement.Header.one'), value:0 },
        { label: this.$t('ChannelManagement.Header.two'), value:1 },
      ],
      KU_LIST: [],
      RETAILER_LIST: [
        { label: 'OfficeWork', value: 'OfficeWork' },
      ],
      ShopifyRemarks:null,
      LIXINGRemarks:null,
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    // 是否指定发货仓
    changeKu(n,m) {
      if(n === 0){
        this.form.distributionCenterType = 0
        this.form.distributionCenterName = null
        this.form.distributionCenterId = null
        this.form.cangCenterName = null
      }
      if(n === 1){
        this.form.distributionCenterType = 1
        this.getDistributionCenterList().then(res=>{
          this.KU_LIST = []
          res.forEach(item => {
            this.KU_LIST.push({
              label: item.name,
              value: item.id
            });
          });
        })
      }
    },
    chooseCenter(n,m){
      this.form.cangCenterName = n
      this.form.distributionCenterName = m.label
      this.form.distributionCenterId = m.value
    },
    getRemarks(){
      const POST_DATA = {
        apiServiceUrl: this.form.apiServiceUrl,
        appKey: this.form.appKey,
        appSecret: this.form.appSecret,
        appType: this.form.channelTypeCode,
      }
      reportApi.getStoreVerifyRemarks(POST_DATA).then(res=>{
        if(!res.skuQty){
          this.LIXINGRemarks = 
          `${this.$t('ChannelManagement.Header.ps0')}${this.$t('ChannelManagement.Header.ps2')}${res.orderQty}${this.$t('ChannelManagement.Header.ps3')}${res.orderConditionQty}.`
        }else{
          this.ShopifyRemarks = 
          `${this.$t('ChannelManagement.Header.ps0')}${this.$t('ChannelManagement.Header.ps1')}${res.skuQty}${this.$t('ChannelManagement.Header.ps2')}${res.orderQty}${this.$t('ChannelManagement.Header.ps3')}${res.orderConditionQty}.`
        }
      })
    },
    // 获取指定仓库下拉列表以供单选
    getDistributionCenterList() {
      // 小知识：方法回调
      return new Promise((resolve, reject) => {
        reportApi.getShopifyGetLocations({ account: this.form.code }).then(res => {
          resolve(res)
        });
      })
    },
    // 获取所属公司
    getSalesOrganizingId() {
      channelApi.getSalesOrganizationTree({ flag: true }).then(res => {
        if (!res.length) return;
        this.form.salesOrganizingId = res[0].id;
      });
    },
    // 获取渠道仓
    getChannelWarehouse() {
      commonApi
        .getListWarehouses({
          typeCode: ['channel'],
          status: 1,
        })
        .then(res => {
          if (!res.length) return;
          this.form.channelWarehouseName = res[0].name;
          this.form.channelWarehouseId = res[0].id;
        });
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit ? this.$t('ChannelManagement.new.editShop') : this.$t('ChannelManagement.new.NEW'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
      this.form.autoTableStatus = String(this.form.autoTableStatus);
      this.ShopifyRemarks = null
      this.LIXINGRemarks = null
      // 3:Shopify(legacy)   21:LIXING-MULTI   22:Shopify
      if(['3', '21','22'].includes(this.form.channelTypeCode) && this.isEdit){
        this.getDistributionCenterList().then(res=>{
          this.KU_LIST = []
          if(res.failed==true){
            this.KU_LIST.push({
              label: info.distributionCenterName,
              value: info.distributionCenterId
            });
          }else{
            res && res.forEach(item => {
              this.KU_LIST.push({
                label: item.name,
                value: item.id
              });
            });
          }
          this.form.cangCenterName = this.form.distributionCenterId?Number(this.form.distributionCenterId):null
        })
      }
      if (!this.isEdit) {
        this.getChannelWarehouse();
        this.getSalesOrganizingId();
      }
    },
    getChannelName(n, m) {
      const selectedChannelTypeCode = (m && m.value !== undefined && m.value !== null) ? m.value : n;
      this.ruleLabel = (m && m.label) || '';
      // 清空表单数据为默认值
      const defaultForm = getDefaultForm();
      Object.keys(this.form).forEach(key => {
        this.form[key] = defaultForm[key] !== undefined ? defaultForm[key] : null;
      });
      this.form.channelTypeCode = selectedChannelTypeCode === undefined || selectedChannelTypeCode === null ? null : String(selectedChannelTypeCode);

      if (!this.isEdit) {
        this.getChannelWarehouse();
        this.getSalesOrganizingId();
      }
      // 根据渠道类型设置对应的 API 服务地址
      if (this.ruleLabel == 'ChannelAdvisor') {
        this.form.apiServiceUrl = 'https://api.channeladvisor.com/oauth2/token';
      } else if (this.ruleLabel == 'LingXing Multi') {
        this.form.apiServiceUrl = 'https://openapi.lingxing.com';
      } else if (this.ruleLabel == 'CIN7') {
        this.form.apiServiceUrl = 'https://api.cin7.com';
      } else {
        this.form.apiServiceUrl = null;
      }
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      API_DATA.orderStartTime = this.form.orderStartTime || null;
      API_DATA.isWriteBackCapture = !!this.form.isWriteBackCapture;
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
        this.saveApi(API_DATA);
      } else {
        const DATA = {
          apiServiceUrl: this.form.apiServiceUrl,
          appKey: this.form.appKey,
          appSecret: this.form.appSecret,
          appType: this.form.channelTypeCode,
          orderStartTime: this.form.orderStartTime,
          isWriteBackCapture: !!this.form.isWriteBackCapture,
        };
        if (this.form.channelTypeCode == '1') {
          DATA.authorization = this.form.authorization;
          DATA.refreshToken = this.form.refreshToken;
        } else {
          DATA.authorization = null;
          DATA.refreshToken = null;
        }
        // 这些店铺需要验证后才能新建
        if (['ChannelAdvisor', 'Shopify', 'WooCommerce', 'Magento', 'CIN7', 'BigCommerce', 'Maropost', 'Unleashed','LingXing Multi','ShopifyGraphQL','Shopify Fulfillment Service'].includes(this.ruleLabel)) {
          channelApi.checkShopConfig(DATA).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.saveApi(API_DATA);
            }
          });
        } else {
          this.saveApi(API_DATA);
        }
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      channelApi.saveOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
